/** @internal */
export function getFocusFactory() {

    return ["$timeout", ($timeout) => {

        return {

            link: (scope, element, attrs) => {

                var watcher: Function;

                var watch = attrs.omniaFocus;

                if (watch) {

                    watcher = scope.$watch(attrs.omniaFocus, value => {

                        if (value) {
                            watcher();
                            focus();
                        }

                    });

                }
                else {

                    focus();

                }

                function focus() {

                    var e = element[0];

                    $timeout(() => {

                        e.focus();

                        if (e instanceof HTMLInputElement) {
                            e.select()
                        }

                    });

                }

            }

        }

    }];

}
